
import React, { useState } from 'react';
import { Dropdown, Button } from 'react-bootstrap';
import { Filter } from 'lucide-react';
import styles from '../../../assets/styles/components/FilterDropdown.module.scss';

interface FilterDropdownProps {
    title?: string;
    onApply: () => void;
    onReset: () => void;
    children: React.ReactNode;
    toggleLabel?: string;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
    title = 'Filter',
    onApply,
    onReset,
    children,
    toggleLabel = 'Filters',
}) => {
    const [show, setShow] = useState(false);

    const handleApply = () => {
        onApply();
        setShow(false);
    };

    const handleReset = () => {
        onReset();
        setShow(false);
    };

    return (
        <Dropdown show={show} onToggle={(isOpen) => setShow(isOpen)}>
            <Dropdown.Toggle variant="primary" id="filter-dropdown" className="d-flex align-items-center gap-2 text-white">
                <Filter size={18} />
                {toggleLabel}
            </Dropdown.Toggle>

            <Dropdown.Menu className={`${styles.filterDropdownMenu} p-4`} style={{ right: 0, left: 'auto' }}>
                <div className="d-flex flex-column">
                    <div className="mb-3 dropdownHeader">
                        <div className={styles.dropdownHeader}>
                            <h6>{title}</h6>
                        </div>
                    </div>

                    <div className="d-flex flex-wrap gap-3">
                        {children}
                    </div>

                    {/* Actions */}
                    <div className="d-flex align-items-end gap-2 ms-auto mt-3">
                        <Button
                            variant="primary"
                            className="text-white"
                            onClick={handleApply}
                        >
                            Apply
                        </Button>
                        <Button
                            variant="outline-secondary"
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                    </div>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default FilterDropdown;
